
import { Theme } from '@mui/material/styles';
import { makeStyles } from 'tss-react/mui';
import EDIconButton from '../../../../BaseComponents/Buttons/IconButton/EDIconButton';

export interface ICustomTopToolbarProps {
  open: boolean;
  onCloseButtonClick: () => void;
  onOpenButtonClick: () => void;
  sideMenuOpen: boolean;
  togglePinned?: () => void;
}

const useStyles = makeStyles()(
  (theme: Theme) =>
    ({
      container: {
        display: 'flex',
        padding: '24px 0px 8px 4px',
        marginLeft: '12px',
        marginRight: '12px',
        position: 'relative',
      },

      containerClosed: {
        display: 'flex',
        padding: '24px 0px 8px 4px',
        marginLeft: '12px',
        marginRight: '12px',
        position: 'relative',
      },
      openCloseButton: {
        marginTop: theme.spacing(0),
        marginBottom: theme.spacing(0),
        position: 'relative',
        bottom: 9.5,
        marginLeft: 0,
      },
      buttonContainer: {
        display: 'flex',
        justifyContent: 'flex-end',
        width: '100%',
      },
    } as const)
);

const KalenderSideMenuToolbar: React.FunctionComponent<
  React.PropsWithChildren<ICustomTopToolbarProps>
> = ({ open, onCloseButtonClick, onOpenButtonClick, sideMenuOpen }) => {
  const { classes, cx } = useStyles();
  return (
    <div
      className={cx(classes.container, {
        [classes.containerClosed]: !open,
        // [classes.containerOpen]: sideMenuOpen,
      })}
    >
      <EDIconButton
        tooltip={open ? 'Stäng' : 'Öppna'}
        onClick={open ? onCloseButtonClick : onOpenButtonClick}
        icon={open ? 'chevron_left' : 'chevron_right'}
        className={classes.openCloseButton}
        testId={
          open
            ? 'chevron_left_kalendar_side_menu'
            : 'chevron_right_kalendar_side_menu'
        }
      />
    </div>
  );
};

export default KalenderSideMenuToolbar;
